function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M60.2101 73.9634L78.0468 94.2927C78.5929 94.9151 79.6701 94.6463 79.8474 93.8435L99.1367 6.50876C99.3083 5.7319 98.4842 5.11387 97.7192 5.44566L6.0502 45.2037C5.19629 45.5741 5.24267 46.7342 6.12241 47.0097L33.1657 55.4806",
  stroke: "currentColor",
  strokeWidth: 10,
  strokeLinecap: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M92.1717 11.584L43 67.0322V80.8943",
  stroke: "currentColor",
  strokeWidth: 10,
  strokeLinecap: "round"
});

var SvgIcShared = function SvgIcShared(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 100,
    viewBox: "0 0 105 100",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcShared, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_shared.6ce5e740.svg";
export { ForwardRef as ReactComponent };